<div *ngIf="{ agreements: agreements$ | async, agreementsError: agreementsError$ | async } as vm">
  <div class="pt-6 flex-1 subnav__exists" [ngClass.lt-md]="{ mobile: true }">
    <ng-container *ngIf="!vm.agreementsError">
      <div class="flex justify-end items-center">
        <sbnb-search-bar
          class="w-96"
          placeholderText="Agreement name, reservation code, or guest name..."
          [initialVal]="searchCriteria"
          [debounceTimeMs]="1500"
          (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
      </div>
    </ng-container>

    <!-- Loading -->
    <ng-container *ngTemplateOutlet="loadingSection; context: { vm: vm }"></ng-container>

    <!-- Error -->
    <ng-container *ngTemplateOutlet="errorSection; context: { vm: vm }"></ng-container>

    <!-- No agreements created yet -->
    <ng-container *ngTemplateOutlet="noDataSection; context: { vm: vm }"></ng-container>

    <!-- Happy path - we have agreements -->
    <section *ngIf="vm.agreements?.data?.length > 0">
      <!-- Desktop - table view-->
      <section class="hidden lg:block">
        <div class="hidden md:flex space-x-3 rules__rule-header">
          <div class="w-[33%]">Agreement</div>
          <div class="w-[33%]">Reservation</div>
          <div class="w-[33%]">Signed on</div>
        </div>

        <a
          *ngFor="let agreement of vm.agreements.data"
          class="rules__rule-container md:flex md:items-center space-x-3 flex-col md:flex-row items-start"
          (click)="onClickAgreement(agreement)">
          <div class="w-[33%] inline-flex space-x-2">
            <strong>{{ agreement.name }}</strong>
          </div>

          <div class="w-[33%] inline-flex">
            <div class="flex space-x-3 items-center">
              <img
                class="w-10 h-10 rounded-full shrink-0"
                [src]="agreement.reservation.guest.picture"
                alt="Guest picture"
                onerror="this.src='/assets/images/profile-default.png'" />

              <div class="flex flex-col">
                <span class="text-sm">{{ agreement.reservation.guest.name }}</span>
                <span class="text-xs">
                  {{ agreement.reservation.check_in_date }} - {{ agreement.reservation.check_out_date }}
                </span>
                <span class="text-xs">{{ agreement.reservation.reservation_code }}</span>
              </div>
            </div>
          </div>

          <div class="w-[33%] md:w-auto flex items-center text-sm">
            <ng-container *ngIf="agreement.signed_at">
              {{ agreement.signed_at | date: 'mediumDate' }} by {{ agreement.signatory }}
            </ng-container>
            <ng-container *ngIf="!agreement.signed_at">
              <span class="badge badge-raspberry">Pending</span>
            </ng-container>
          </div>
        </a>
      </section>

      <!-- Mobile - card view -->
      <section class="lg:hidden p-2 space-y-2">
        <mat-card
          *ngFor="let agreement of vm.agreements.data"
          class="cursor-pointer"
          (click)="onClickAgreement(agreement)">
          <mat-card-content>
            <strong class="mb-2 block">{{ agreement.name }}</strong>

            <div class="flex space-x-3 items-center">
              <img
                class="w-10 h-10 rounded-full shrink-0"
                [src]="agreement.reservation.guest.picture"
                alt="Guest picture"
                onerror="this.src='/assets/images/profile-default.png'" />

              <div class="flex flex-col">
                <span class="text-sm">{{ agreement.reservation.guest.name }}</span>
                <span class="text-xs">
                  {{ agreement.reservation.check_in_date }} - {{ agreement.reservation.check_out_date }}
                </span>
                <span class="text-xs">{{ agreement.reservation.reservation_code }}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </section>

      <sbnb-pagination
        *ngIf="vm.agreements?.meta?.pagination?.page_numbers?.total_pages > 1"
        position="end"
        [pageCount]="vm.agreements?.meta?.pagination?.page_numbers?.total_pages"
        [currentPage]="vm.agreements?.meta?.pagination?.page_numbers?.this_page"
        (pageChanged)="onPageChange($event)"></sbnb-pagination>
    </section>
  </div>
</div>

<ng-template #loadingSection let-vm="vm">
  <ng-container *ngIf="vm.agreements?.data === null && !vm.agreementsError">
    <div class="hidden lg:block">
      <div class="animate-pulse space-y-2">
        <!-- Row shimmers -->
        <div *ngFor="let i of [].constructor(20)" class="space-y-2">
          <div class="flex items-center space-x-3 p-4 border-b border-gray-200">
            <div class="w-[33%]">
              <div class="h-4 bg-gray-200 rounded w-3/4"></div>
            </div>
            <div class="w-[33%] flex space-x-3">
              <div class="w-10 h-10 bg-gray-200 rounded-full shrink-0"></div>
              <div class="space-y-2 flex-1">
                <div class="h-3 bg-gray-200 rounded w-1/2"></div>
                <div class="h-2 bg-gray-200 rounded w-3/4"></div>
                <div class="h-2 bg-gray-200 rounded w-1/4"></div>
              </div>
            </div>
            <div class="w-[33%]">
              <div class="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lg:hidden">
      <div class="animate-pulse space-y-2">
        <div *ngFor="let i of [].constructor(20)" class="space-y-2">
          <mat-card>
            <mat-card-content>
              <div class="h-5 bg-gray-200 rounded w-1/2 mb-4"></div>

              <div class="flex space-x-3 items-center">
                <div class="w-10 h-10 bg-gray-200 rounded-full shrink-0"></div>
                <div class="space-y-2 flex-1">
                  <div class="h-3 bg-gray-200 rounded w-4/12"></div>
                  <div class="h-2 bg-gray-200 rounded w-5/12"></div>
                  <div class="h-2 bg-gray-200 rounded w-1/4"></div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #errorSection let-vm="vm">
  <ng-container *ngIf="vm.agreementsError">There was an error loading your signed reservation agreements.</ng-container>
</ng-template>

<ng-template #noDataSection let-vm="vm">
  <ng-container *ngIf="vm.agreements?.data?.length === 0 && !vm.agreementsError">
    <sbnb-no-items text="No reservation agreements found"></sbnb-no-items>
  </ng-container>
</ng-template>
